// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tag[data-v-3f0fab7a]{display:flex;align-items:center;justify-content:center;--bg-opacity:1;background-color:#f8f5f5;background-color:rgba(248,245,245,var(--bg-opacity));padding:.25rem .75rem;margin-right:.5rem;font-size:.875rem;border-radius:11.5px}.slide-enter-active[data-v-3f0fab7a],.slide-leave-active[data-v-3f0fab7a]{transition:all .3s ease}.slide-enter[data-v-3f0fab7a],.slide-leave-to[data-v-3f0fab7a]{height:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
